// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.top-hero-section {
  position: relative;
  width: 100%;
   height: 300px; /* NEW - Adjust as needed */
  overflow: hidden;
}

/* Background image */
.top-hero-section img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/* 
/* Gradient overlay */
.top-hero-section .overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(168, 139, 235, 0.4), rgba(0, 0, 0, 0.6));
}

/* Centered text */
.top-hero-section .text-content {
  position: relative;
  z-index: 10;
  color: white;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 1rem;
}

.top-hero-section h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0;
}

.top-hero-section p {
  margin-top: 0.75rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.middle-section {
  /* background-color: white;    */
  color: black;
  padding: 4rem 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  max-width: 80rem;
  margin: 0 auto;
}
/* 
.middle-section p {
  margin-bottom: 1.5rem;
} */

/* Bottom CTA */
.bottom-cta {
  background-color: #2F4D38;
  color: white;
  text-align: center;
  padding: 4rem 1rem;
}

.bottom-cta .cta-container {
  max-width: 40rem;
  margin: 0 auto;
}

.bottom-cta h3 {
  font-size: 1.25rem;
  font-weight: 500;
}

.bottom-cta p {
  font-size: 1.125rem;
  margin: 1rem 0;
}

.bottom-cta button {
  background-color: white;
  color: #2F4D38;
  padding: 0.5rem 1.5rem;
  font-weight: 500;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.bottom-cta button:hover {
  background-color: #f0f0f0;
}
.top-hero-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f0f4f8; /* Change this color as needed */
  padding: 60px 40px;
  gap: 2rem;
  flex-wrap: wrap;
}

.text-box {
  flex: 1 1;
  max-width: 600px;
  margin-left: 100px;
}

.text-box h1 {
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1.4;
  color: #2f4d38;
}

.image-box {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.image-box img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
.bottom-cta {
  background-color: #066222;
  color: white;
  text-align: center;
  /* padding: 4rem 1rem; */
}

.hero-banner {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
}

.hero-bg-img {
  width: 100%;
  height: 100%;
  opacity: 20px;
  opacity: 0.4; /* 👈 Reduced image opacity */
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  padding: 20px;
}

.hero-text h1 {
  font-size: 3rem;
  font-weight: 700;
  line-height: 1.2;
  display: flex;
  align-items: center ;
  color: #066222;
}


.cta-container h3 {
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.cta-container p {
  font-size: 1.125rem;
  /* margin-bottom: 2rem; */
  line-height: 1.6;
}

.cta-container button {
  background-color: white;
  color: #2F4D38;
  padding: 0.75rem 2rem;
  font-weight: 600;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.cta-container button:hover {
  background-color: #e2e2e2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TestingService.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;GACV,aAAa,EAAE,2BAA2B;EAC3C,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;qBACqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,oFAAoF;AACtF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;;;GAGG;;AAEH,eAAe;AACf;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB,EAAE,gCAAgC;EAC3D,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY,EAAE,6BAA6B;AAC7C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Container */\r\n.top-hero-section {\r\n  position: relative;\r\n  width: 100%;\r\n   height: 300px; /* NEW - Adjust as needed */\r\n  overflow: hidden;\r\n}\r\n\r\n/* Background image */\r\n.top-hero-section img {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n/* \r\n/* Gradient overlay */\r\n.top-hero-section .overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: linear-gradient(to bottom, rgba(168, 139, 235, 0.4), rgba(0, 0, 0, 0.6));\r\n}\r\n\r\n/* Centered text */\r\n.top-hero-section .text-content {\r\n  position: relative;\r\n  z-index: 10;\r\n  color: white;\r\n  text-align: center;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  padding: 0 1rem;\r\n}\r\n\r\n.top-hero-section h1 {\r\n  font-size: 2.5rem;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.top-hero-section p {\r\n  margin-top: 0.75rem;\r\n  max-width: 600px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.middle-section {\r\n  /* background-color: white;    */\r\n  color: black;\r\n  padding: 4rem 1rem;\r\n  font-size: 1.125rem;\r\n  line-height: 1.75rem;\r\n  max-width: 80rem;\r\n  margin: 0 auto;\r\n}\r\n/* \r\n.middle-section p {\r\n  margin-bottom: 1.5rem;\r\n} */\r\n\r\n/* Bottom CTA */\r\n.bottom-cta {\r\n  background-color: #2F4D38;\r\n  color: white;\r\n  text-align: center;\r\n  padding: 4rem 1rem;\r\n}\r\n\r\n.bottom-cta .cta-container {\r\n  max-width: 40rem;\r\n  margin: 0 auto;\r\n}\r\n\r\n.bottom-cta h3 {\r\n  font-size: 1.25rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.bottom-cta p {\r\n  font-size: 1.125rem;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.bottom-cta button {\r\n  background-color: white;\r\n  color: #2F4D38;\r\n  padding: 0.5rem 1.5rem;\r\n  font-weight: 500;\r\n  border: none;\r\n  border-radius: 9999px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.bottom-cta button:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n.top-hero-flex {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: #f0f4f8; /* Change this color as needed */\r\n  padding: 60px 40px;\r\n  gap: 2rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.text-box {\r\n  flex: 1;\r\n  max-width: 600px;\r\n  margin-left: 100px;\r\n}\r\n\r\n.text-box h1 {\r\n  font-size: 2.5rem;\r\n  font-weight: bold;\r\n  line-height: 1.4;\r\n  color: #2f4d38;\r\n}\r\n\r\n.image-box {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.image-box img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  object-fit: contain;\r\n}\r\n.bottom-cta {\r\n  background-color: #066222;\r\n  color: white;\r\n  text-align: center;\r\n  /* padding: 4rem 1rem; */\r\n}\r\n\r\n.hero-banner {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 400px;\r\n  overflow: hidden;\r\n}\r\n\r\n.hero-bg-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 20px;\r\n  opacity: 0.4; /* 👈 Reduced image opacity */\r\n}\r\n\r\n.hero-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: white;\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n.hero-text h1 {\r\n  font-size: 3rem;\r\n  font-weight: 700;\r\n  line-height: 1.2;\r\n  display: flex;\r\n  align-items: center ;\r\n  color: #066222;\r\n}\r\n\r\n\r\n.cta-container h3 {\r\n  font-size: 1.75rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.cta-container p {\r\n  font-size: 1.125rem;\r\n  /* margin-bottom: 2rem; */\r\n  line-height: 1.6;\r\n}\r\n\r\n.cta-container button {\r\n  background-color: white;\r\n  color: #2F4D38;\r\n  padding: 0.75rem 2rem;\r\n  font-weight: 600;\r\n  border-radius: 9999px;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-size: 1rem;\r\n}\r\n\r\n.cta-container button:hover {\r\n  background-color: #e2e2e2;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
